<div class="recipient-list">
  <div *ngIf="loading" class="row row--first">Loading recipients…</div>
  <div *ngIf="error" class="row row--first">{{ error }}</div>
  <ng-container *ngIf="!loading && !error">
    <div cdkDropList (cdkDropListDropped)="drop($event)">
      <div class="row" *ngFor="let r of recipients; let i = index; trackBy: trackByEmail" [class.row--first]="i === 0" cdkDrag>
        <div class="order-badge">
          <span class="drag-handle" cdkDragHandle>⁝⁝</span>
          <span class="avatar" [style.background]="getAvatarColor(r?.roleName)">{{ getInitials(r?.roleName) }}</span>
          <div class="name">{{ getDisplayName(r) }} <span>({{r?.roleName}})</span></div>
        </div>
        <div class="identity" style="padding-left: 3rem;">
          <div class="contact-chips">
            <span class="channel-chip channel-capsule" *ngIf="getDisplayEmail(r) as email">
              <span>EMAIL</span> {{ email }}
            </span>
            <span class="channel-chip channel-capsule" *ngIf="getDisplayPhone(r) as phone">{{ formatPhone(phone) }}</span>
          </div>
          <div class="channels">
            <label class="channel-checkbox" [class.channel-checkbox--readonly]="isChannelReadonly(r)">
              <input type="checkbox" [checked]="hasChannel(r, 'Email')" [disabled]="isChannelReadonly(r)" (change)="toggleChannel(r, 'Email', $event)" />
              Email
            </label>
            <ng-container *ngIf="getDisplayPhone(r)">
              <label class="channel-checkbox" [class.channel-checkbox--readonly]="isChannelReadonly(r)">
                <input type="checkbox" [checked]="hasChannel(r, 'SMS')" [disabled]="isChannelReadonly(r)" (change)="toggleChannel(r, 'SMS', $event)" />
                SMS
              </label>
              <label class="channel-checkbox" [class.channel-checkbox--readonly]="isChannelReadonly(r)">
                <input type="checkbox" [checked]="hasChannel(r, 'WhatsApp')" [disabled]="isChannelReadonly(r)" (change)="toggleChannel(r, 'WhatsApp', $event)" />
                WhatsApp
              </label>
            </ng-container>
          </div>
        </div>
        <div class="row-placeholder" *cdkDragPlaceholder></div>
      </div>
    </div>
  </ng-container>
</div>
